import jsonp from "jsonp"

export class Caller {

    constructor({baseUrl}) {
        this.baseUrl = baseUrl
    }

    /**
     * Call jsonp request
     * @param params
     */
    async call(params = {}) {
        return new Promise((success) => {
            jsonp(this.buildUrl(params), {param: "jsonpCallback"}, (err, data) => {
                if (err) throw new Error(err)
                success(data)
            })
        })
    }

    /**
     * Post request
     * @param params
     * @param body
     */
    async post({params = {}, body}) {
        return new Promise((success, error) => {
            const init = {
                method: "POST",
                body
            }
            fetch(this.buildUrl(params), init).then(response => {
                return response.json().then(json => {
                    if (response.ok) success(json)
                    else error(json)
                })
            })
        })
    }

    buildUrl(params) {
        let url = this.baseUrl
        for (let k in params) {
            if (typeof params[k] === "undefined") continue
            let prefix = url.indexOf("?") === -1 ? "?" : "&"
            url += `${prefix}${k}=${params[k]}`
        }
        return url
    }
}